<div class="ambassador_progression">
    
    <div class="ambassador_progression_title">
        <ion-icon name="trending-up-outline"></ion-icon>
        {{'AMBASSADOR_PROGRESSION.TITLE' | translate}}
    </div>
    
    @if(this.displayNbPoints || this.displayRanking){
        <div class="ambassador_progression_content_stats">
            @if(this.displayNbPoints){
                <div id="ambassador_nb_points" class="ambassador_progression_stats">
                    <div class="ambassador_progression_stats_title">{{'AMBASSADOR_PROGRESSION.POINTS' | translate}}</div>
                    <div class="ambassador_progression_stats_value">{{this.ambassador?._pcd?.points}}</div>
                </div>
            }
            @if(this.displayRanking){
                <div class="ambassador_progression_stats">
                    <div class="ambassador_progression_stats_title">{{'AMBASSADOR_PROGRESSION.RANKING' | translate}}</div>
                    <div class="ambassador_progression_stats_value">{{(this.ambassador?._pcd?.ranking ? this.ambassador?._pcd?.ranking : '-')}}</div>
                </div>
            }
        </div>
    }
    
    @if(this.displayLevelProgression){
        <div class="ambassador_progression_level">
            <div class="ambassador_progression_level_stats">
                <div>
                    @if(this.nextLevel){
                        {{this.translateService.instant('AMBASSADOR_PROGRESSION.PROGRESSION_NEXT_LEVEL').replace('{level}', this.nextLevel.name).replace('{points}', (this.currentLevel.maxPoints - this.ambassador?._pcd?.points))}}
                    }
                    @else{
                        {{this.currentLevel?.name}}
                    }
                </div>
                <div>
                    {{this.ambassador?._pcd?.points || 0}}
                    @if(this.nextLevel){
                        &nbsp;/&nbsp;{{this.currentLevel.maxPoints}}
                    }
                    &nbsp;{{'AMBASSADOR_PROGRESSION.PTS' | translate}}
                </div>                
            </div>
            
            <demooz-progress-bar 
                [value]="this.progressLevel"               
                [showSepValue]="false"
                [showValue]="false"
                [withMargin]="false"
                size="very-small"
                />
                        
            @if(this.dateUpdate){
                <div>{{'AMBASSADOR_PROGRESSION.UPDATE' | translate}} : {{this.dateUpdate | demoozDateToString}}</div>
            }
            
        </div>
    }
</div>